export default function FormFieldFooter({
  error,
  errorId,
  charLeft,
  hint,
  charactersLeftLabel,
}) {
  return (
    <div className="mt-0.5 min-h-[1rem]">
      <div className="flex justify-between items-start gap-2">
        {error ? (
          <p
            id={errorId}
            className="text-xs text-cfIssuedCredentialTemplateCardStatusFailedBG leading-tight"
          >
            {error}
          </p>
        ) : hint ? (
          <p className="text-[11px] text-cfViewAllTagText leading-tight">{hint}</p>
        ) : (
          <span className="flex-1" />
        )}
        {charLeft !== undefined && (
          <span className="text-xs text-cfViewAllTagText whitespace-nowrap shrink-0">
            {charLeft} {charactersLeftLabel}
          </span>
        )}
      </div>
    </div>
  );
}
